(ns frontend.ui.component.lp-portal.one-column-table.view
  (:require
   [frontend.ui.component.lp-portal.strong-label.view :refer [strong-label]]
   [frontend.ui.component.table.view :refer [table tbody td tr]]))

(defn one-column-table
  [{:keys [dom-key] :as props} rows-data]
  [table {}
   [tbody {:dom-key dom-key}
    (->> rows-data
         (map-indexed (fn [idx {:keys [label value style]}]
                        (tr {:dom-key (str dom-key "-" idx)}
                            [td {} [strong-label label]]
                            [td
                             (merge {:style {:white-space "nowrap"
                                             :text-align  "right"}}
                                    style)
                             value])))
         (doall))]])
